import { getFunctions, httpsCallable } from "firebase/functions";
import { app } from "../firebase";

export const quitarAdmin = async (email: string) => {
	const functions = getFunctions(app);
	const removeAdminRole = httpsCallable(functions, "removeAdminRole");

	try {
		const res = await removeAdminRole({ email });
		return res.data;
	} catch (error: any) {
		throw new Error(error.message || "Error al quitar rol de administrador.");
	}
};